<!-- eslint-disable vue/no-unused-vars -->
<!-- eslint-disable max-len -->
<template>
    <div v-if="isLoading" class="d-flex align-items-center" style="gap: 5px">
        <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
        <span>{{ $t('components.datatable.index.loadingText') }}</span>
    </div>
    <template v-else>
        <div class="d-flex sm-flex-column" style="gap: 30px">
            <ImagePlaceholder :img_url="detail.product?.img_url" width="180" height="180" style="border-radius: 5px" />
            <div class="w-100">
                <div style="font-size: 14px; font-weight: 500; line-height: 21px; color: #00203f">
                    {{ detail.product?.title }}
                </div>
                <div class="w-100 d-flex align-items-center justify-content-between sm-flex-column" style="border: 1px solid #e7eaf3; border-radius: 10px; margin-top: 15px">
                    <div class="w-100 d-flex align-items-center justify-content-between" style="padding: 10px 15px">
                        <span style="font-size: 12px; font-weight: 600; line-height: 21px; color: #677788">ASIN</span>
                        <InventoryClipboard :asin="detail.identifiers?.asin" style="font-size: 12px" />
                    </div>
                    <div class="w-100 d-flex align-items-center justify-content-between" style="padding: 10px 15px; border-left: 1px solid #e7eaf3; border-right: 1px solid #e7eaf3">
                        <span style="font-size: 12px; font-weight: 600; line-height: 21px; color: #677788">SKU</span>
                        <InventoryClipboard type="sku" :asin="detail.identifiers?.asin" :sku="detail.identifiers?.sku" style="font-size: 12px" />
                    </div>
                    <div class="w-100 d-flex align-items-center justify-content-between" style="padding: 10px 15px">
                        <span style="font-size: 12px; font-weight: 600; line-height: 21px; color: #677788">{{ $t('views.inventory.modals.productDetail.detail.openDate') }}</span>
                        <span style="font-size: 12px; font-weight: 400; line-height: 21px; color: #677788">{{ formatDate(detail.product?.open_date) }}</span>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-between sm-flex-column sm-align-items-start" style="margin-top: 20px">
                    <div class="d-flex sm-flex-column" style="gap: 15px">
                        <button type="button" class="btn btn-sm btn-primary d-flex align-items-center" style="gap: 5px" @click="setAddToRestrictedProduct">
                            <i class="bi-plus-lg"></i>
                            <span>{{ detail.statuses?.restricted_product_list ? $t('views.inventory.modals.productDetail.detail.restrictedProduct.remove') : $t('views.inventory.modals.productDetail.detail.restrictedProduct.add') }}</span>
                        </button>
                        <button type="button" class="btn btn-sm btn-primary d-flex align-items-center" style="gap: 5px" @click="setAddToRestrictedBrand">
                            <i class="bi-plus-lg"></i>
                            <span>{{ detail.statuses?.restricted_brand_list ? $t('views.inventory.modals.productDetail.detail.restrictedBrand.remove') : $t('views.inventory.modals.productDetail.detail.restrictedBrand.add') }}</span>
                        </button>
                        <multiselect
                            v-show="getShortFromMarket.length > 1"
                            v-model="selectedSourceMarket"
                            placeholder="Kaynak seçin"
                            :show-labels="false"
                            :multiple="true"
                            :searchable="false"
                            :options="getShortFromMarket"
                            :preselect-first="true"
                            :close-on-select="false"
                            :clear-on-select="false"
                        >
                            <template v-slot:selection="{ values, isOpen }"
                                ><span class="multiselect__single d-flex align-items-center" style="gap: 5px" v-if="values.length" v-show="!isOpen"
                                    ><img class="option__image" :src="require(`@/assets/svg-flag/${values[0]}.svg`)" />
                                    <span class="d-flex align-items-center"
                                        >{{ values[0] }} <template v-if="values.length > 1">+{{ values.length - 1 }}</template></span
                                    ></span
                                ></template
                            >
                            <template v-slot:option="{ option }">
                                <img class="option__image" :src="require(`@/assets/svg-flag/${option}.svg`)" />
                                <div class="option__desc d-flex justify-content-between" style="width: 100%; margin-left: 7px">
                                    <span class="option__title">{{ option }}</span>
                                    <span v-if="selectedSourceMarket.includes(option)"><i class="bi-check-lg text-success"></i></span>
                                </div>
                            </template>
                        </multiselect>
                        <Popper v-if="detail.product?.variations_count" class="d-flex align-items-center" hover arrow>
                            <template v-if="selectedSourceMarket.length === 0" #content>{{ $t('views.inventory.modals.productDetail.detail.selectSourceCountry') }}</template>
                            <button type="button" class="btn btn-sm btn-secondary d-flex align-items-center" :disabled="selectedSourceMarket.length === 0" style="gap: 5px; padding: 10px 15px" @click="handleVariationScan">
                                <i class="bi-search"></i> <span>{{ $t('views.inventory.modals.productDetail.detail.scanVariant') }}</span>
                            </button>
                        </Popper>
                    </div>
                    <div>
                        <button type="button" class="btn btn-sm btn-outline-secondary d-flex align-items-center" style="gap: 5px" @click="deleteProductConfirm">
                            <i class="bi-trash3"></i> <span>{{ $t('views.inventory.modals.productDetail.detail.removeProduct') }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <table class="table table-borderless table-thead-bordered border table-align-middle modal-table sm-d-block" style="margin-top: 20px">
            <thead class="thead-light">
                <tr>
                    <th>{{ $t('views.inventory.modals.productDetail.detail.columns.stock') }}</th>
                    <th>{{ $t('views.inventory.modals.productDetail.detail.columns.minPrice') }}</th>
                    <th>{{ $t('views.inventory.modals.productDetail.detail.columns.salesPrice') }}</th>
                    <th>{{ $t('views.inventory.modals.productDetail.detail.columns.maxPrice') }}</th>
                    <th>{{ $t('views.inventory.modals.productDetail.detail.columns.taxFee') }}</th>
                    <th style="max-width: 150px">{{ $t('views.inventory.modals.productDetail.detail.columns.cog') }}</th>
                    <th>{{ $t('views.inventory.modals.productDetail.detail.columns.status') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ detail.inventory?.total_quantity }}</td>
                    <td>
                        <div v-if="detail.prices?.min_prices" class="d-flex" style="gap: 5px">
                            <span>{{ detail.prices?.currency }}</span>
                            <strong>{{ formatNumber(detail.prices?.min_prices) }}</strong>
                        </div>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <div v-if="detail.prices?.price" class="d-flex" style="gap: 5px">
                            <span>{{ detail.prices?.currency }}</span>
                            <strong>{{ formatNumber(detail.prices?.price) }}</strong>
                        </div>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <div v-if="detail.prices?.max_price" class="d-flex" style="gap: 5px">
                            <span>{{ detail.prices?.currency }}</span>
                            <strong>{{ formatNumber(detail.prices?.max_price) }}</strong>
                        </div>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <div v-if="detail.calculated?.total_fee_tax" class="d-flex" style="gap: 5px">
                            <span>{{ detail.calculated?.currency }}</span>
                            <strong>{{ formatNumber(detail.calculated?.total_fee_tax) }}</strong>
                        </div>
                        <template v-else>-</template>
                    </td>
                    <td style="max-width: 150px">
                        <div class="d-flex align-items-center" style="gap: 5px">
                            <div v-if="detail.isCogInputloading" class="spinner-border spinner-border-sm text-primary" role="status"></div>
                            <span>{{ detail.costs?.currency }}</span>
                            <CurrencyInput
                                v-model="cost_of_goods"
                                :currency="detail.costs?.currency"
                                :options="{ valueRange: { min: 0, max: undefined } }"
                                :disabled="detail.expenses_count >= 2 || detail.isCogInputloading"
                                class="form-control form-control-sm"
                                style="max-width: 80px; min-height: 14px !important; padding: 2px 2px 2px 5px !important; font-weight: 600; font-size: 0.8rem"
                                @focus="() => (storeCOG = detail.costs?.cost_of_goods)"
                                @blur="updateCost(detail.id, cost_of_goods)"
                            />
                        </div>
                    </td>
                    <td>
                        <div class="d-flex flex-column justify-content-start align-items-start">
                            <span class="badge" :class="detail.statuses?.status === 1 ? 'bg-success' : 'bg-danger'">{{ detail.statuses?.status === 1 ? $t('views.inventoryStatus.active') : $t('views.inventoryStatus.inactive') }}</span>
                            <span v-if="detail.statuses?.is_buybox" class="text-muted" style="font-weight: 400; font-size: 11px">BuyBox</span>
                            <span v-if="detail.statuses?.is_lowest" class="text-muted" style="font-weight: 400; font-size: 11px">Lowest</span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="row g-0" style="margin-top: 20px">
            <div class="col-xs-12 col-lg-6">
                <table class="table table-borderless table-bordered modal-table specs">
                    <tbody>
                        <tr>
                            <td>{{ $t('views.inventory.modals.productDetail.detail.columns2.productViolationCase') }}</td>
                            <td>
                                <span v-if="detail.statuses?.restricted_product" class="badge bg-danger text-white">{{ detail.statuses?.restricted_product }}</span>
                                <template v-else>-</template>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('views.inventory.modals.productDetail.detail.columns2.brand') }}</td>
                            <td>{{ detail.product?.brand }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('views.inventory.modals.productDetail.detail.columns2.category') }}</td>
                            <td>{{ detail.product?.category }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('views.inventory.modals.productDetail.detail.columns2.salesRank') }}</td>
                            <td>
                                {{ detail.product?.bsr ? new Intl.NumberFormat().format(detail.product?.bsr) : '-' }}
                            </td>
                        </tr>
                        <tr v-if="detail.product?.variations_count">
                            <td>{{ $t('views.inventory.modals.productDetail.detail.columns2.variantNumber') }}</td>
                            <td>{{ detail.product?.variations_count }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-xs-12 col-lg-6">
                <table class="table table-borderless table-bordered modal-table specs">
                    <tbody>
                        <tr>
                            <td>{{ $t('views.inventory.modals.productDetail.detail.columns2.numberOfFbaSeller') }}</td>
                            <td>{{ detail.offers?.fba_sellers_count }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('views.inventory.modals.productDetail.detail.columns2.numberOfFbmSeller') }}</td>
                            <td>{{ detail.offers?.fbm_sellers_count }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('views.inventory.modals.productDetail.detail.columns2.myPastSalesNumber') }}</td>
                            <td>{{ detail.calculated?.sales_count }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('views.inventory.modals.productDetail.detail.columns2.myPastReturnNumber') }}</td>
                            <td>{{ detail.calculated?.refund_count }}</td>
                        </tr>
                        <tr v-if="detail.product?.variations_count">
                            <td style="background-color: #f8fafd; border: none"></td>
                            <td style="background-color: #f8fafd; border: none"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row g-0" style="margin-top: 20px">
            <div class="col-xs-12 col-lg-6">
                <span style="font-size: 14px; font-weight: 500; line-height: 21px; color: #00203f">{{ $t('views.inventory.modals.productDetail.detail.columns2.packageInformation') }}</span>

                <div class="d-flex align-items-center justify-content-between w-100" style="margin-top: 10px">
                    <table class="table table-borderless table-bordered modal-table w-100">
                        <tbody>
                            <tr>
                                <td style="width: 134.5px">{{ $t('views.inventory.modals.productDetail.detail.columns2.width') }}</td>
                                <td style="width: 134.5px">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <strong>{{ detail.dimensions?.imperial?.width }}</strong>
                                        <span>{{ detail.dimensions?.imperial?.dimensionUnit }}</span>
                                    </div>
                                </td>
                                <td style="width: 134.5px">{{ $t('views.inventory.modals.productDetail.detail.columns2.lbs') }}</td>
                                <td style="width: 134.5px">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <strong>{{ detail.dimensions?.imperial?.dimWeight }}</strong>
                                        <span>{{ detail.dimensions?.imperial?.dimensionUnit }}</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style="width: 134.5px">{{ $t('views.inventory.modals.productDetail.detail.columns2.height') }}</td>
                                <td style="width: 134.5px">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <strong>{{ detail.dimensions?.imperial?.height }}</strong>
                                        <span>{{ detail.dimensions?.imperial?.dimensionUnit }}</span>
                                    </div>
                                </td>
                                <td style="width: 134.5px">{{ $t('views.inventory.modals.productDetail.detail.columns2.weight') }}</td>
                                <td style="width: 134.5px">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <strong>{{ detail.dimensions?.imperial?.weight }}</strong>
                                        <span>{{ detail.dimensions?.imperial?.dimensionUnit }}</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style="width: 134.5px">{{ $t('views.inventory.modals.productDetail.detail.columns2.length') }}</td>
                                <td style="width: 134.5px">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <strong>{{ detail.dimensions?.imperial?.length }}</strong>
                                        <span>{{ detail.dimensions?.imperial?.dimensionUnit }}</span>
                                    </div>
                                </td>
                                <td style="width: 134.5px">{{ $t('views.inventory.modals.productDetail.detail.columns2.shipping') }}</td>
                                <td style="width: 134.5px">
                                    <img src="@/assets/img/buyshipping-logo.svg" width="67" height="14" alt="" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-xs-12 col-lg-6">
                <Box3D
                    :params="{
                        dimension: {
                            width: detail.dimensions?.imperial?.width,
                            height: detail.dimensions?.imperial?.height,
                            length: detail.dimensions?.imperial?.length,
                            weight: detail.dimensions?.imperial?.weight,
                            lbs: detail.dimensions?.imperial?.dimWeight,
                            asin: detail.product?.identifiers?.asin,
                            _index: 0,
                        },
                        lbs: detail.dimensions?.imperial?.dimWeight,
                        shipping_method: {
                            depot_price: 24.18,
                            service_id: 16,
                            last_update: '2024-10-08 14:23:14',
                            queue: false,
                            active: true,
                            depot_offer_price: 38.55,
                            depot_offer_other_price: 0,
                            buying_price: 38.55,
                            late_delivery: false,
                            shipping_day_first: 4,
                            shipping_day_last: 7,
                            offer_seller_id: 'AD1Q66LVLV2PG',
                            offer_seller_name: 'KitchenLogic',
                        },
                    }"
                ></Box3D>
            </div>
        </div>
    </template>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Box3D from '@/components/Inventory/Box3D.vue'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import { countryInfo } from '@/utils/helper'
import CurrencyInput from '@/components/CurrencyInput.vue'
import InventoryClipboard from '../../InventoryClipboard.vue'
import ImagePlaceholder from '../../ImagePlaceholder.vue'

const countries = countryInfo()

export default {
    name: 'ProductDetailDetailModal',
    components: {
        Box3D,
        Multiselect,
        CurrencyInput,
        InventoryClipboard,
        ImagePlaceholder,
    },
    data() {
        return {
            countries,
            selectedSourceMarket: [],
            cost_of_goods: null,
            storeCOG: '',
            isLoading: true,
        }
    },
    computed: {
        ...mapState('inventory', ['list', 'selectedRows', 'detail']),
        ...mapGetters('market', ['markets', 'currentMarket']),
        getShortFromMarket() {
            const currentMarketShort = this.markets.find((market) => market.short === this.currentMarket.short)
            return currentMarketShort.sources.map((market) => market.source)
        },
    },
    created() {
        this.getDetail().finally(() => {
            this.isLoading = false
            this.cost_of_goods = this.detail.costs?.cost_of_goods
        })
    },
    methods: {
        ...mapActions('inventory', ['productDetail', 'addToRestrictedProduct', 'removeRestrictedProduct', 'addToRestrictedBrand', 'removeRestrictedBrand', 'deleteProduct', 'variationScan', 'createExpenses', 'getDetail']),
        closeModal() {
            this.$emit('update:modelValue', false)
        },
        formatDate(date) {
            return moment(date).format('DD/MM/YYYY')
        },
        formatNumber(number) {
            if (number === null || number === undefined) return null

            const factor = Math.pow(10, 2)
            const rounded = Math.floor(number * factor + 1e-9) / factor
            return rounded.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })
        },
        deleteProductConfirm() {
            if (confirm(this.$t('views.inventory.modals.productDetail.detail.toast.deleteProduct.confirm', { sku: this.detail?.identifiers?.sku }))) {
                this.deleteProduct().then(() => {
                    this.closeModal()
                })
            }
        },
        handleVariationScan() {
            if (confirm(this.$t('views.inventory.modals.productDetail.detail.toast.variationScan.confirm'))) {
                this.variationScan({ sources: this.selectedSourceMarket })
            }
        },
        updateCost(inventoryId, value) {
            this.detail.isCogInputloading = true
            if (this.storeCOG !== value) {
                const payload = [{ amount: null, price: value, end_date: '' }]
                this.createExpenses({ id: inventoryId, payload }).finally(() => {
                    this.detail.isCogInputloading = false
                })
            }
        },
        setAddToRestrictedProduct() {
            if (this.detail.statuses?.restricted_product_list) {
                this.removeRestrictedProduct()
            } else {
                this.addToRestrictedProduct()
            }
        },
        setAddToRestrictedBrand() {
            if (this.detail.statuses?.restricted_brand_list) {
                this.removeRestrictedBrand()
            } else {
                this.addToRestrictedBrand()
            }
        },
    },
}
</script>

<style lang="scss">
.dp__theme_light {
    --dp-primary-color: #ffb53e;
}
.custom-form-control {
    max-height: 37px;
    font-size: 12px;
}
[id^='ProductDetail-'] {
    .modal-body {
        padding-top: 32px !important;
    }
    .close-button {
        width: 35px;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;

        &:hover {
            background-color: #f8fafd;
        }
    }
    .modal-table {
        margin-bottom: 0 !important;
        border-radius: 5px;

        &.specs {
            td {
                width: 269px;
                height: 45px;

                &:nth-child(odd) {
                    border-right: 0 !important;
                }
            }
        }

        tbody {
            tr {
                td {
                    font-size: 12px;
                    font-weight: 600;
                    line-height: 21px;
                    color: #677788;
                    height: 41px;
                }
                td:nth-child(odd) {
                    border-right: none;
                }
                td:nth-child(even) {
                    font-weight: 400;
                    color: #677788;
                    border-left: none;
                }
            }
        }

        .text-ellipsis {
            font-size: 11.9px;
            font-weight: 400;
            line-height: 17.9px;
            color: #677788;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;

            &.title {
                max-width: 250px;
            }

            &.category {
                max-width: 125px;
            }
        }
        .dp__input_wrap {
            width: auto;
            > input {
                padding-inline-end: 12px !important;
                font-size: 14px;
                border: 0.6px solid #e7eaf3;
                color: #677788;
                width: 125px !important;
            }
        }
    }

    .nav-segment {
        margin-right: 2rem;

        .nav-link {
            font-weight: 500;
            font-size: 14px;
        }
    }

    .multiselect {
        width: 140px !important;
        min-width: auto !important;

        &__placeholder {
            display: block !important;
            margin-bottom: 0 !important;
            padding-top: 0 !important;
        }

        &__tags {
            padding: 12px 40px 0 8px !important;
        }

        &__select {
            line-height: normal !important;
        }
    }
}
</style>
